module.exports = __webpack_public_path__ + "static/media/power-management.4ecdf072.jpeg";